import { PRODUCTS } from '../stripe-config';
import { supabase } from './db';

export async function createCheckoutSession(
  priceId: string, 
  mode: 'payment' | 'subscription', 
  billingAddress?: { street: string; city: string; postalCode: string },
  voucherCode?: string | null
) {
 console.log('[Checkout] Starting createCheckoutSession...');
 console.log('[Checkout] Price ID:', priceId);
 console.log('[Checkout] Mode:', mode);
  console.log('[Checkout] Billing Address:', billingAddress);
  console.log('[Checkout] Voucher Code:', voucherCode);
  
 const { data: { session }, error: sessionError } = await supabase.auth.getSession();
 if (sessionError) {
   console.error('[Checkout] Session fetch error:', sessionError);
 }
 if (!session) {
   console.error('[Checkout] No session found. Aborting.');
   throw new Error('Not authenticated');
 }
 console.log('[Checkout] Session acquired. Access token:', session.access_token ? '✔️ present' : '❌ missing');
 
 const body: Record<string, any> = {
   price_id: priceId,
   mode,
   success_url: `${window.location.origin}/payment-required?checkout=success`,
   cancel_url: `${window.location.origin}/registrieren`,
   billing_address: billingAddress,
   voucher_code: voucherCode
  };
 console.log('[Checkout] Sending POST to Edge Function with body:', body);
 
 const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/stripe-checkout`, {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json',
     'Authorization': `Bearer ${session.access_token}`,
   },
   body: JSON.stringify(body),
 });
 
 if (!response.ok) {
   const errorResponse = await response.json();
   console.error('[Checkout] Failed to create checkout session:', errorResponse);
   throw new Error(errorResponse.error || errorResponse.message || 'Die Bezahlseite konnte nicht erstellt werden.');
 }
 
 const { url } = await response.json();
  console.log('[Checkout] Checkout session created. Redirecting...');
 
 return url;
}

export async function getActiveSubscription() {
  const { data: subscription, error } = await supabase
    .from('stripe_user_subscriptions')
    .select('*')
    .maybeSingle();

  if (error) {
    console.error('Error fetching subscription:', error);
    return null;
  }

  return subscription;
}

export async function getOrderHistory() {
  const { data: orders, error } = await supabase
    .from('stripe_user_orders')
    .select('*')
    .order('order_date', { ascending: false });

  if (error) {
    console.error('Error fetching orders:', error);
    return [];
  }

  return orders;
}

export function getProductById(productId: keyof typeof PRODUCTS) {
  return PRODUCTS[productId];
}